import { useCallback } from "react";
import client from "../api/client";

const dataUrlToBlob = (dataUrl) => {
  const [meta, b64] = dataUrl.split(",");
  const bytes = atob(b64);
  const buf = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) buf[i] = bytes.charCodeAt(i);
  return new Blob([buf], { type: meta.includes("png") ? "image/png" : "image/jpeg" });
};

// Uploads camera frames straight to S3 with presigned URLs so image bytes never
// pass through the API — this is what keeps the morning check-in rush cheap to scale.
export const useFrameUpload = () => {
  return useCallback(async (frames) => {
    const { data } = await client.post("/attendance/frame-urls", { count: frames.length });
    await Promise.all(
      data.slots.map((slot, i) =>
        fetch(slot.url, {
          method: "PUT",
          headers: { "Content-Type": "image/jpeg" },
          body: dataUrlToBlob(frames[i]),
        }).then((r) => {
          if (!r.ok) throw new Error("frame_upload_failed");
        })
      )
    );
    return data.slots.map((s) => s.key);
  }, []);
};
